import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { colors } from "theme";
import {
  CheckboxContainer,
  FilterBadgeWrapper,
  FilterSelectContainer,
} from "pages/Claims/styles";
import { Ptag } from "components/core";

function Filter({ filters, onChange, text, category, showFilterNo = true }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterStatusSelected, setFilterStatusSelected] = useState(new Set([]));

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // if (filterStatusSelected.size === 0) {
    //   return;
    // }
    onChange(filterStatusSelected);
  }, [filterStatusSelected]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filterHandler = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckbox = (status) => {
    if (filterStatusSelected.has(status)) {
      setFilterStatusSelected((prev) => {
        prev.delete(status);
        return new Set(prev);
      });
    } else {
      setFilterStatusSelected((prev) => {
        prev.add(status);
        return new Set(prev);
      });
    }
  };
  const isChecked = (status) => {
    return filterStatusSelected.has(status);
  };
  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: {
            marginTop: "8px",
            // border: "1px solid #D0D5DD",
            border: "1px solid rgba(255, 255, 255, 1)",
            boxShadow:
              "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
            "&:hover": {
              boxShadow:
                "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
              backgroundColor: "white",
            },
            borderRadius: "10px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <section>
          <FormControl
            style={{
              margin: "12px",
            }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              {category ? (
                <FilterSelectContainer>
                  {filters.map(([category, options]) => (
                    <div key={category}>
                      <Ptag fontSize="12px" marginBottom="8px">
                        {category}
                      </Ptag>
                      <CheckboxContainer>
                        {options.map((status) => (
                          <FormControlLabel
                            key={status}
                            control={
                              <Checkbox
                                checked={isChecked(status)}
                                onChange={() =>
                                  handleCheckbox(status, category)
                                }
                                name={status}
                                style={{
                                  transform: "scale(1.4)",
                                  color: colors.primaryColor,
                                }}
                              />
                            }
                            label={<Ptag fontSize="12px">{status.replaceAll("_", " ")}</Ptag>}
                          />
                        ))}
                      </CheckboxContainer>
                    </div>
                  ))}
                </FilterSelectContainer>
              ) : (
                filters.map((status) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked(status)}
                        onChange={() => handleCheckbox(status)}
                        name={status}
                        style={{
                          transform: "scale(1.4)",
                          color: colors.primaryColor,
                        }}
                      />
                    }
                    label={<Ptag fontSize="12px">{status}</Ptag>}
                  />
                ))
              )}
            </FormGroup>
          </FormControl>
        </section>
      </Popover>
      <Button
        variant="contained"
        startIcon={<FilterListIcon color="black" />}
        onClick={filterHandler}
        sx={{
          // backgroundColor: colors.whiteColor,
          backgroundColor: "transparent",
          fontSize: "14px",
          textTransform: "capitalize",
          fontFamily: "Montserrat",
          border: "1px solid rgba(255, 255, 255, 1)",
          color: "#344054",
          // height: "44px",
          borderRadius: "8px",
          padding: "8px 12px 8px 12px",
          boxShadow:
            "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
          "&:hover": {
            boxShadow:
              "inset 2px 2px 5px rgba(0, 0, 0, 0.08), inset -1px -1px 3px rgba(255, 255, 255, 0.9)",
            backgroundColor: "transparent",
          },
        }}
      >
        {text || "Status"}
        {filterStatusSelected.size > 0 && showFilterNo && (
          <FilterBadgeWrapper>
            <p>{filterStatusSelected.size}</p>
          </FilterBadgeWrapper>
        )}
      </Button>
    </>
  );
}

export default Filter;
